import { render, staticRenderFns } from "./StarInactive.vue?vue&type=template&id=6295459b&"
import script from "./StarInactive.vue?vue&type=script&lang=js&"
export * from "./StarInactive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports